export default {
  CREATE_USER_PROFILE(state, payload) {
    console.group("CREATE_USER_PROFILE");

    const userId = payload.userId;
    const user = state.userProfiles.filter((user) => {
      return userId === user.userId;
    });

    if (user.length === 0) {
      // no user profile found, valid to add
      // console.log("CREATE_USER_PROFILE: adding userId = " + payload.userId);

      const newUser = {
        userId: payload.userId,
        userName: payload.userName,
        email: payload.email,
        isAdmin: payload.isAdmin,
        dateAdded: payload.dateAdded,
      };

      state.userProfiles.push(newUser);

      // console.log(
      //   "CREATE_USER_PROFILE: total users = " + state.userProfiles.length
      // );
      // console.log("CREATE_USER_PROFILE: userProfiles = ", state.userProfiles);
    } else {
      // user profile already exists, use it
      console.log("CREATE_USER_PROFILE: existing userId = " + payload.userId);
      this.SET_USER_PROFILE(state, payload.userId);
    }

    console.groupEnd();
  },
  SET_USER_PROFILE(state, userId) {
    console.group("SET_USER_PROFILE");
    console.info("userId = " + userId);
    console.info("userProfiles");
    console.table(state.userProfiles);

    const user = state.userProfiles.filter((user) => {
      return userId === user.userId;
    });

    console.info("user array = ", user);
    if (user.length !== 1) {
      console.info("no user for userId = " + userId);

      state.currentUser.userId = null;
      state.currentUser.userName = null;
      state.currentUser.email = null;
      state.currentUser.isAdmin = false;
      state.currentUser.dateAdded = null;
    } else {
      console.info("existing user, userId = " + userId);

      // state.currentUser = user[0];
      Object.assign(state.currentUser, user[0]);
    }
    console.groupEnd();
  },
  CLEAR_USER_PROFILE(state) {
    console.group("CLEAR_USER_PROFILE");
    console.info("initial userProfiles = ", state.userProfiles);
    console.info("prev userId = " + state.currentUser.userId);

    state.currentUser.userId = null;
    state.currentUser.userName = null;
    state.currentUser.email = null;
    state.currentUser.isAdmin = false;
    state.currentUser.dateAdded = null;

    console.info("final userProfiles = ", state.userProfiles);
    console.groupEnd();
  },
  UPDATE_USER_PROFILE(state, profile) {
    console.group("UPDATE_USER_PROFILE");
    console.info("update profile = ", profile);

    for ( var i = 0; i < state.userProfiles.length; i++ )     {
      if ( state.userProfiles[i].userId === profile.userId ) {
        Object.assign(state.userProfiles[i], profile);
        console.info("updated userProfiles["+i+"] = ", state.userProfiles[i]);
      }
    }
    console.groupEnd();
  },
  CLEAR_ALL_USERS(state) {
    console.group("CLEAR_ALL_USERS");
    state.userProfiles.length = 0;
    console.groupEnd();
  },
  LOAD_USER(state, user) {
    console.group("LOAD_USER");

    const newUser = new Object;
    Object.assign(newUser, user);

    state.userProfiles.push(newUser);
    console.info("newUser = ", newUser);
    console.info("userProfiles = ", state.userProfiles.length);
    console.groupEnd();
  }
};
